import { NgModule } from '@angular/core';

import { CmpsObjectStoreModule } from '../object-store';

import { CallService, SocketService } from './core';
import { CmpsLocalCallHudModule } from './hud';
import { CmpsLocalCallVoiceProfileModule } from './voice-profile';

@NgModule({
    imports: [
        CmpsLocalCallHudModule,
        CmpsLocalCallVoiceProfileModule,
        CmpsObjectStoreModule,
    ],
    providers: [CallService, SocketService],
})
export class CmpsLocalCallModule {}
